module.exports = __webpack_public_path__ + "fonts/avenir/212ab03d-5db2-4d6a-b94c-171cc702aa51.eot";


//////////////////
// WEBPACK FOOTER
// ./fonts/avenir/212ab03d-5db2-4d6a-b94c-171cc702aa51.eot
// module id = 23
// module chunks = 0